import { render, staticRenderFns } from "./SettingsLive.vue?vue&type=template&id=61c6ac82&scoped=true"
import script from "./SettingsLive.vue?vue&type=script&lang=js"
export * from "./SettingsLive.vue?vue&type=script&lang=js"
import style0 from "./SettingsLive.vue?vue&type=style&index=0&id=61c6ac82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c6ac82",
  null
  
)

export default component.exports